(async section_name => {
    let wait = 200;
    while (!window.Swiper && wait--) await new Promise(r => setTimeout(r, 150));
    new Swiper(`.${section_name}_swiper`, {
        // Optional parameters
        direction: 'horizontal',
        pagination: {
            el: `.${section_name}-swiper-pagination`,
        },

        // Responsive breakpoints (optional)
        breakpoints: {
            300: {
                slidesPerView: 1,
            },
            400: {
                slidesPerView: 1.2,
                spaceBetween: 12
            },
            600: {
                slidesPerView: 1.4,
                spaceBetween: 12
            },
            768: {
                slidesPerView: 3,
                loop: false,
                spaceBetween: 12
            },
            1024: {
                slidesPerView: 3,
                loop: false,
                spaceBetween: 12
            },
        },
    });
})("acc-st-product-101_03").catch(console.info);
